/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

/*
* Sorting for Data Table body
* */

import Vue from 'vue'

export default Vue.extend({
  data () {
    return {
      sortBy: null,
      sortDesc: null
    }
  },
  methods: {
    customSort (items: any, sortBy: any, sortDesc: any) {
      if (sortBy !== this.sortBy || sortDesc !== this.sortDesc) {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.$emit('sortBy', sortBy, sortDesc ? -1 : 1)
      }
      return items
    }
  }
})
